<script>
	import Router from 'svelte-spa-router';
	import routes from './routes';
</script>

<main class="select-none">
	<Router {routes} />
</main>